import { FiRefreshCcw } from "react-icons/fi";

function ReloadSpinner() {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <FiRefreshCcw 
        style={{
          animation: "spin 1s linear infinite", // rotation continue
          fontSize: "24px"
        }}
      />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default ReloadSpinner;
